// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"26323995","685":"175c582d","726":"0046b79e","787":"ddf9605b"}[chunkId] + ".chunk.js";
};